import { Language } from '@openeducation/oe-rn-shared-types';
import { atom } from 'jotai';

export const preferredLanguageAtom = atom<Language>(Language.EN);
